<template>
	<div>
		<h1>{{ $t('profile.title') }}</h1>

		<p>
			{{ $t('profile.client') }} :
			<span v-b-tooltip.hover :title="client.uid">{{ client.nom }}</span>
		</p>
		<p>{{ $t('profile.name') }} : {{ name }}</p>
		<p>{{ $t('profile.family_name') }} : {{ family }}</p>
		<p>{{ $t('profile.mail') }} : {{ email }}</p>
	</div>
</template>

<script>
	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import password from "../services/password.js";

	export default {
		name: "profile",
		data() {
			return {
				user: "",
				name: "",
				family: "",
				id: "",
				email: "",
				jwt: "",
				password: null,
				password_length: 0,
				contains_eight_characters: false,
				contains_number: false,
				contains_uppercase: false,
				contains_special_character: false,
				valid_password: false,
				client: { env: "", details: { profile: {} } },
				env_list: [""],
				store: {},
				user_groups: [],
				group: "",
				groups: [],
				obj_groups: {},
			};
		},
		methods: {
			async update() {
				if (!this.user.env) 
					this.user.env = null;
				var user = await users.updateUserSelf(this.user, this.group || null);
				this.$router.go();
			},
			async generate_jwt()
			{
				this.jwt = await users.generateJwtSelf();
				this.user.jwt = this.jwt;
			},
			onSubmit(evt) {
				evt.preventDefault();
				password.set_password(this.password, this.token).then((res) => {
					this.$router.push({ name: "logout" });
				});
			},
			checkPassword() {
				this.password_length = this.password.length;
				const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

				if (this.password_length > 8) {
					this.contains_eight_characters = true;
				} else {
					this.contains_eight_characters = false;
				}

				this.contains_number = /\d/.test(this.password);
				this.contains_uppercase = /[A-Z]/.test(this.password);
				this.contains_special_character = format.test(this.password);

				if (
					this.contains_eight_characters === true &&
					this.contains_special_character === true &&
					this.contains_uppercase === true &&
					this.contains_number === true
				) {
					this.valid_password = true;
				} else {
					this.valid_password = false;
				}
			},
			getUserSelf: async function () {
				try {
					this.user = await users.getSelf();
					this.name = this.user.prenom;
					this.family = this.user.nom;
					this.id = this.user.identifiant;
					this.email = this.user.email;

					if (!this.user.details) this.user.details = {};

					this.jwt = this.user.jwt || "non défini";

					if (!this.user.env) this.user.env = "";
				} catch (error) {
					console.log(error);
				}
			},
		},
		created: async function () {

			this.store = store;
			
			await this.getUserSelf();

			let response = await users.getSelf(true);

			this.client = response.client;

			if (!this.client.details) this.cient.details = {};

			if (!this.client.details.profile) this.client.details.profile = {};

			if (!this.client.details.env) this.client.details.env = {};

			if (this.user.groups && this.user.groups.indexOf("|") > 0) 
			{
				this.user_groups = this.user.groups.split("|");
				this.group = this.user_groups[0];

				var groups = await client.getClientGroups();

				this.obj_groups = {};
				for (var i = 0; i < groups.length; i++) 
				{
					if (this.user_groups.includes(groups[i].uid))
					{
						this.obj_groups[groups[i].uid] = groups[i];
						this.groups.push({
							value: groups[i].uid,
							text: groups[i].name,
						});
					}
				}

			}

			this.env_list = [""];
			var keys = Object.keys(this.client.details.env);
			for (var i = 0; i < keys.length; i++) {
				this.env_list.push({
					text: this.client.details.env[keys[i]].name,
					value: keys[i],
				});
			}
		},
	};
</script>

<style scoped>
	ul {
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	li {
		margin-bottom: 8px;
		color: #525f7f;
		position: relative;
	}

	li:before {
		content: "";
		width: 0%;
		height: 2px;
		background: #2ecc71;
		position: absolute;
		left: 0;
		top: 50%;
		display: block;
		transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}

	/* Password Input --------- */

	.input_container {
		position: relative;
		padding: 30px;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
			0 6px 6px rgba(0, 0, 0, 0.23);
		border-radius: 6px;
		background: #fff;
	}

	input[type="password"] {
		line-height: 1.5;
		display: block;
		color: rgba(136, 152, 170, 1);
		font-weight: 300;
		width: 100%;
		height: calc(2.75rem + 2px);
		padding: 0.625rem 0.75rem;
		border-radius: 0.25rem;
		background-color: #fff;
		transition: border-color 0.4s ease;
		border: 1px solid #cad1d7;
		outline: 0;
	}

	input[type="password"]:focus {
		border-color: rgba(50, 151, 211, 0.45);
	}

	/* Checkmark & Strikethrough --------- */

	.is_valid {
		color: rgba(136, 152, 170, 0.8);
	}
	.is_valid:before {
		width: 100%;
	}

	.checkmark_container {
		border-radius: 50%;
		position: absolute;
		top: -15px;
		right: -15px;
		background: #2ecc71;
		width: 50px;
		height: 50px;
		visibility: hidden;
		opacity: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.4s ease;
	}

	.show_checkmark {
		visibility: visible;
		opacity: 1;
	}

	.checkmark {
		width: 100%;
		height: 100%;
		fill: none;
		stroke: white;
		stroke-width: 15;
		stroke-linecap: round;
		stroke-dasharray: 180;
		stroke-dashoffset: 180;
	}

	.checked {
		animation: draw 0.5s ease forwards;
	}

	@keyframes draw {
		to {
			stroke-dashoffset: 0;
		}
	}
</style>
